export interface Produto {
  CB1COD: string;
  CB1DESC: string;
  CB1XDESCL: string;
  CB1UM: string;
  CB1SEGUM: string;
  CB1TIPO: string;
  CB1MRP: string;
  CB1POSIPI: string;
  CB1LOCPAD: string;
  CB1CONTA: string;
  CB1XCTACUS: string;
  CB1XCTADEC: string;
  CB1XCTADEA: string;
  CB1XCTADEF: string;
  NB1EMAX: number;
  NB1EMIN: number;
  $selected: boolean;
}
export interface ProdutoLista {
  items: Array<Produto>;
  hasNext: boolean;
}

export const defaultProduto = (): Produto => {
  return{
    CB1COD: '',
    CB1DESC: '',
    CB1XDESCL: '',
    CB1UM: '',
    CB1SEGUM: '',
    CB1TIPO: '',
    CB1MRP: '',
    CB1POSIPI: '',
    CB1LOCPAD: '',
    CB1CONTA: '',
    CB1XCTACUS: '',
    CB1XCTADEC: '',
    CB1XCTADEA: '',
    CB1XCTADEF: '',
    NB1EMAX: 0,
    NB1EMIN: 0,
    $selected: false,
  };
};

export interface FiltroProdutoLista {
  CB1MSBLQL: string;
  CB1COD: string;
  CB1DESC: string;
  CGRPNVL1: string;
  CGRPNVL2: string;
  CB1XPDM: string;
  CB1POSIPI: string;
  page: number;
};

export const defaultFiltroProdutoLista = (): FiltroProdutoLista => {
  return {
    CB1MSBLQL: '2',
    CB1COD: '',
    CB1DESC: '',
    CGRPNVL1: '',
    CGRPNVL2: '',
    CB1XPDM: '',
    CB1POSIPI: '',
    page: 1
  };
};
